import { Store } from '@reduxjs/toolkit';
import { ReducersInjectorWithState, StoreType } from '@wajeez-web/stores/base';
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';

import { AccountState } from './account/types';
import accountReducer from './account/slices';
import { UserSummariesState } from './userSummaries/types';
import userSummariesReducer from './userSummaries/slices';
import { UtilityUsersState } from './utilityUsers/types';
import salesReducer from './utilityUsers/slices';

export let accountStore: StoreType<{
  account: AccountState;
  userSummaries: UserSummariesState;
  sales: UtilityUsersState;
}>;

export type AccountDispatch = typeof accountStore.dispatch;
export type AccountStoreState = ReturnType<typeof accountStore.getState>;

export const useAccountDispatch = () => useDispatch<AccountDispatch>();
export const useAccountSelector: TypedUseSelectorHook<AccountStoreState> =
  useSelector;

export const getAccountState = (store: Store) =>
  store.getState() as AccountStoreState;

export const injectAccountReducers: ReducersInjectorWithState<
  AccountStoreState
> = () => {
  return [
    {
      name: 'account',
      reducer: accountReducer,
    },
    {
      name: 'userSummaries',
      reducer: userSummariesReducer,
    },
    {
      name: 'sales',
      reducer: salesReducer,
    },
  ];
};
